module.exports = __webpack_public_path__ + "static/teaser-509c42dfe4c3b413a73d27be96f80169.gif";